window.EG_HELP_CENTRE_UPLOADS = {
syncUploadedAttachmentFields: function (form, files) {
  form.querySelectorAll('input[data-uploaded-attachment="true"]').forEach(function (el) {
    el.remove();
  });

  if (!files || !files.length) return;

  var lines = files
    .filter(function (file) {
      return file && file.url;
    })
    .map(function (file, idx) {
      var number = idx + 1;
      var name = file.name || ('File ' + number);
      return number + '. ' + name + ' - ' + file.url;
    });

  if (!lines.length) return;

  var uploadedFilesField = document.createElement('input');
  uploadedFilesField.type = 'hidden';
  uploadedFilesField.name = 'contact[Uploaded Files]';
  uploadedFilesField.value = lines.join('\n');
  uploadedFilesField.setAttribute('data-uploaded-attachment', 'true');

  form.appendChild(uploadedFilesField);
},

  compressImageFile: function (file) {
    return new Promise(function (resolve) {
      if (!file || !file.type || file.type.indexOf('image/') !== 0) {
        resolve(file);
        return;
      }

      if (file.type === 'image/gif') {
        resolve(file);
        return;
      }

      var reader = new FileReader();

      reader.onload = function (evt) {
        var img = new Image();

        img.onload = function () {
          var maxWidth = 1600;
          var maxHeight = 1600;
          var width = img.width;
          var height = img.height;

          if (width > maxWidth || height > maxHeight) {
            var ratio = Math.min(maxWidth / width, maxHeight / height);
            width = Math.round(width * ratio);
            height = Math.round(height * ratio);
          }

          var canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;

          var ctx = canvas.getContext('2d');
          if (!ctx) {
            resolve(file);
            return;
          }

          ctx.drawImage(img, 0, 0, width, height);

          var outputType = 'image/jpeg';
          if (file.type === 'image/png' || file.type === 'image/webp') {
            outputType = file.type;
          }

          var quality = 0.8;

          canvas.toBlob(function (blob) {
            if (!blob) {
              resolve(file);
              return;
            }

            if (blob.size >= file.size) {
              resolve(file);
              return;
            }

            var compressedFile = new File([blob], file.name, {
              type: outputType,
              lastModified: Date.now()
            });

            resolve(compressedFile);
          }, outputType, quality);
        };

        img.onerror = function () {
          resolve(file);
        };

        img.src = evt.target.result;
      };

      reader.onerror = function () {
        resolve(file);
      };

      reader.readAsDataURL(file);
    });
  },

  bindPreviewUi: function (attachContainer) {
    if (!attachContainer) return;

    var previewArea = attachContainer.querySelector('.cf-attach-preview');
    var MAX_FILE_MB = 25;
    var MAX_IMAGES = 5;
    var uploadCounter = attachContainer.querySelector('.cf-upload-count');

    function updateUploadCounter() {
      if (!uploadCounter) return;
      var count = currentCount();
      uploadCounter.textContent = "(" + count + "/" + MAX_IMAGES + " uploaded)";
    }

    function formatSize(bytes) {
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    function currentCount() {
      return previewArea.querySelectorAll('.cf-thumb-wrapper').length;
    }

    function createPreview(file, inputEl) {
      var wrapper = document.createElement('div');
      wrapper.className = 'cf-thumb-wrapper';

      var isImage = file.type && file.type.startsWith('image/');
      var isPdf = file.type === 'application/pdf';
      var isVideo = file.type && file.type.startsWith('video/');

      if (isImage) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var img = document.createElement('img');
          img.src = e.target.result;
          img.className = 'cf-attach-thumb';
          wrapper.insertBefore(img, wrapper.firstChild);
        };
        reader.readAsDataURL(file);
      } else if (isPdf) {
        var pdfLabel = document.createElement('div');
        pdfLabel.className = 'cf-attach-pdf';
        pdfLabel.textContent = 'PDF: ' + (file.name || 'document.pdf');
        wrapper.appendChild(pdfLabel);
      } else if (isVideo) {
        var videoLabel = document.createElement('div');
        videoLabel.className = 'cf-attach-pdf';
        videoLabel.textContent = 'VIDEO: ' + (file.name || 'video');
        wrapper.appendChild(videoLabel);
      }

      var sizeEl = document.createElement('div');
      sizeEl.className = 'cf-thumb-size';
      sizeEl.textContent = formatSize(file.size);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'cf-remove-thumb';
      removeBtn.innerHTML = '&times;';

      removeBtn.addEventListener('click', function () {
        wrapper.remove();
        inputEl.remove();
        updateUploadCounter();
      });

      wrapper.appendChild(sizeEl);
      wrapper.appendChild(removeBtn);
      previewArea.appendChild(wrapper);
      updateUploadCounter();
    }

    function handleFileSelection(inputEl) {
      inputEl.addEventListener('change', function (e) {
        var file = e.target.files[0];
        if (!file) return;

        var isImage = file.type && file.type.startsWith('image/');
        var isPdf = file.type === 'application/pdf';
        var isVideo = file.type && file.type.startsWith('video/');

        if (!isImage && !isPdf && !isVideo) {
          alert('File type not supported. Please upload an image, video, or PDF.');
          inputEl.value = '';
          return;
        }

        if (currentCount() >= MAX_IMAGES) {
          alert('You can upload a maximum of ' + MAX_IMAGES + ' files.');
          inputEl.value = '';
          return;
        }

        if (file.size > MAX_FILE_MB * 1024 * 1024) {
          alert('This file is too large. Max size: ' + MAX_FILE_MB + 'MB.');
          inputEl.value = '';
          return;
        }

        createPreview(file, inputEl);

        var inputsWrap = attachContainer.querySelector('.cf-attach-inputs');
        if (!inputsWrap) {
          updateUploadCounter();
          return;
        }

        var currentWrapper = inputEl.closest('.cf-upload-wrapper');

        inputEl.style.display = 'none';
        inputsWrap.appendChild(inputEl);

        if (currentWrapper) {
          currentWrapper.remove();
        }

        var newWrapper = document.createElement('div');
        newWrapper.className = 'cf-upload-wrapper';

        var newLabel = document.createElement('label');
        newLabel.className = 'cf-upload-btn';
        newLabel.textContent = 'Add photo/video';

        var newInput = document.createElement('input');
        newInput.type = 'file';
        newInput.name = inputEl.name;
        newInput.accept = inputEl.accept;
        newInput.className = inputEl.className;

        newLabel.appendChild(newInput);
        newWrapper.appendChild(newLabel);

        if (uploadCounter) {
          newWrapper.appendChild(uploadCounter);
        }

        inputsWrap.appendChild(newWrapper);
        handleFileSelection(newInput);
        updateUploadCounter();
      });
    }

    var firstInput = attachContainer.querySelector('.cf-file-input');
    if (firstInput) handleFileSelection(firstInput);
  }
};